import React, { useEffect, useState } from "react";
import CurrencyWord from "../../../../Componets/Currencywords";
import formatDateDDMMYYYY from "../../../../Main/formatDate";
import UserCurrency from "../../../../Componets/UserCurrency";

const InvoiceA5 = React.forwardRef((props, ref) => {
  const { values } = props;

  const [totalPages, setTotalPages] = useState(1);
  const itemsPerPage = 5;

  const getItemsForPage = (page) => {
    if (!values?.details) return [];
    const start = (page - 1) * itemsPerPage;
    return values.details.slice(start, start + itemsPerPage);
  };

  const capitalizeWords = (str) => {
    if (!str) return "";
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  };

  useEffect(() => {
    if (values?.details) {
      setTotalPages(Math.ceil(values.details.length / itemsPerPage));
    }
  }, [values?.details]);

  const injectScopedStyles = () => {
    const style = document.createElement("style");
    style.innerHTML = `
        @page {
          size: A5 landscape;
          margin: 4mm;
        }
    
        @media print {
          .header-section {
            position: fixed;
            top: 0%;
            left: 0%;
            right: 0%;
            background: white;
            z-index: 1000;
            page-break-inside: avoid;
          }
          
          .table-header-section {
            position: fixed;
            top: 38%; 
            left: 0%;
            right: 0%;
            background: white;
            z-index: 999;
            page-break-inside: avoid;
          }
          
          .invoice-content {
            margin-top: 30%; 
          }
          
          .page-break {
            page-break-before: always;
            margin-top: 30%;
          }


             .table-header-section-with-info {
            position: fixed;
            top: 52%; 
            left: 0%;
            right: 0%;
            background: white;
            z-index: 999;
            page-break-inside: avoid;
          }
          
          .invoice-content-with-info {
            margin-top: 40%; 
          }
          
          .page-break-with-info {
            page-break-before: always;
            margin-top: 40%;
          }
          
          .invoice-table {
              table-layout: fixed;
              width: 100%;
            }
  
            .col-sno     { width: 5%; }
            .col-desc    { width: 40%; }
            .col-unit    { width: 10%; }
            .col-qty     { width: 10%; }
            .col-price   { width: 12%; }
            .col-vat     { width: 13%; }
            .col-total   { width: 10%; }
        
        }
      `;
    document.head.appendChild(style);
  };

  useEffect(() => {
    injectScopedStyles();
  }, []);

  const renderHeaderSection = () => (
    <div className="header-section">
      <div className="flex justify-between items-start">
        <div className="text-black-900 text-[0.65rem]">
          <div className="text-bold text-md">
            {capitalizeWords(values?.branch?.name)}
          </div>
          <div className="text-medium text-xs">
            Email&nbsp;:&nbsp;
            {values?.branch?.email ? values?.branch?.email + ", " : ""}
            &nbsp;
          </div>
          <div className="text-medium text-xs">
            Phone&nbsp;:&nbsp;
            {values?.branch?.phone ? values?.branch?.phone : ""}
            &nbsp;
          </div>
          <div className="text-xs">
            {values?.branch?.area ? values?.branch?.area + ", " : ""}
            {values?.branch?.city ? values?.branch?.city + ", " : ""}
            {values?.branch?.country ? values?.branch?.country : ""}
          </div>
          <div className="text-xs">
            VATIN&nbsp;:&nbsp;
            {values?.branch?.tax ? values?.branch?.tax : "N/A"}
          </div>
        </div>
        {values?.branch?.image ? (
          <div className="flex justify-center flex-col items-center">
            <div className="text-xl pb-2">
              <img
                className="w-[40px] h-[40px]"
                src={`${URL}/uploads${values?.branch?.image}`}
                alt="Branch Logo"
              />
            </div>
            <div className="text-bold text-lg">
              {capitalizeWords(values?.branch?.name)}
            </div>
          </div>
        ) : (
          <div className="flex justify-center flex-col items-center">
            <div className="w-[40px] h-[40px] rounded-md bg-gray-300 text-black flex items-center justify-center text-xl font-semibold">
              {values?.branch?.name
                ? values.branch.name.charAt(0).toUpperCase()
                : "N"}
            </div>
            <div className="text-bold text-lg">
              {capitalizeWords(values?.branch?.name)}
            </div>
          </div>
        )}
      </div>

      <hr className="my-1 border-t-black-900 border-black" />
      <div className="text-md text-center">TAX INVOICE</div>
      <hr className="my-1 border-t-black-900 border-black" />

      <div className="border border-gray-300 rounded-lg p-1 shadow-sm">
        <div className="flex justify-between">
          <div>
            <div className="font-semibold text-[0.70rem] mb-2">
              Customer Name
            </div>
            <div className="text-[0.65rem] space-y-1">
              <div className="font-medium">
                {values?.customer?.name
                  ? values?.customer?.name
                  : "Walk-in-customer"}
              </div>

              {values?.customer?.phone && (
                <div>
                  <span className="font-semibold">Phone :</span>{" "}
                  {values?.customer?.phone}
                </div>
              )}

              {values?.customer?.email && (
                <div>
                  <span className="font-semibold">Email :</span>{" "}
                  {values?.customer?.email}
                </div>
              )}

              <div>
                {values?.customer?.city ? values?.customer?.city + ", " : ""}
                {values?.customer?.state}
              </div>

              <div>{values?.customer?.country}</div>

              {values?.customer?.tax && (
                <div>
                  <span className="font-semibold">VATIN :</span>{" "}
                  {values?.customer?.tax}
                </div>
              )}
            </div>
          </div>

          <div>
            <div className="text-[0.65rem] space-y-1">
              <div className="flex">
                <div className="w-24 text-bold">Invoice No</div>
                <div className="px-2">:</div>
                <div className="text-right">#INV-{values?.number}</div>
              </div>
              <div className="flex">
                <div className="w-24 text-bold">Invoice Type</div>
                <div className="px-2">:</div>
                <div className="text-right">
                  {values?.payment_status == 2
                    ? values?.payments
                        ?.map((v, i) => (i > 0 ? ", " : "") + v?.name)
                        .join("")
                    : "CREDIT"}
                </div>
              </div>
              <div className="flex">
                <div className="w-24 text-bold">Date</div>
                <div className="px-2">:</div>
                <div className="text-right">
                  {formatDateDDMMYYYY(values?.date)}
                </div>
              </div>
              {values?.due_date ? (
                <div className="flex">
                  <div className="w-24">Due Date</div>
                  <div className="px-2">:</div>
                  <div className="text-right">
                    {formatDateDDMMYYYY(values?.due_date)}
                  </div>
                </div>
              ) : (
                ""
              )}
              {values?.lpo_number ? (
                <div className="flex">
                  <div className="w-24">Lpo No</div>
                  <div className="px-2">:</div>
                  <div className="text-right">{values?.lpo_number}</div>
                </div>
              ) : (
                ""
              )}
              {values?.lpo_date ? (
                <div className="flex">
                  <div className="w-24">Lpo Date</div>
                  <div className="px-2">:</div>
                  <div className="text-right">
                    {formatDateDDMMYYYY(values?.lpo_date)}
                  </div>
                </div>
              ) : (
                ""
              )}
              {values?.salesman?.name ? (
                <div className="flex">
                  <div className="w-24">Salesman</div>
                  <div className="px-2">:</div>
                  <div className="text-right">{values?.salesman?.name}</div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
  const renderTableHeaders = () => (
    <div
      className={` ${
        values?.customer?.name
          ? "table-header-section-with-info"
          : "table-header-section"
      }`}
    >
      <table className="invoice-table w-full border-separate border-spacing-0 rounded-t-lg overflow-hidden border border-gray-300 mb-0">
        <thead>
          <tr className="bg-gray-100">
            <th className="col-sno text-[0.55rem] text-left py-2 pl-3 border-b border-gray-300 rounded-tl-lg">
              S.NO
            </th>
            <th className="col-desc text-[0.55rem] text-left p-1 border-b border-gray-300">
              DESCRIPTION
            </th>
            <th className="col-unit text-[0.55rem] text-center p-1 border-b border-gray-300">
              UNIT
            </th>
            <th className="col-price text-[0.55rem] text-center p-1 border-b border-gray-300">
              PRICE
            </th>
            <th className="col-qty text-[0.55rem] text-center p-1 border-b border-gray-300">
              QTY
            </th>
            <th className="col-vat text-[0.55rem] text-center p-1 border-b border-gray-300">
              VAT
            </th>
            <th className="col-total text-[0.55rem] text-right pr-2 border-b border-gray-300">
              TOTAL
            </th>
          </tr>
        </thead>
      </table>
    </div>
  );
  const renderTableBody = (pageItems, pageNumber, isLastPage) => (
    <div
      key={`page-${pageNumber}`}
      className={
        pageNumber > 1
          ? values?.customer?.name
            ? "page-break-with-info"
            : "page-break"
          : values?.customer?.name
            ? "invoice-content-with-info"
            : "invoice-content"
      }
    >
      <table className="invoice-table  w-full border-separate border-spacing-0 overflow-hidden border border-gray-300 border-t-0">
        <tbody className="text-sm">
          {pageItems.map((value, index) => {
            const isLastDataRow = index === pageItems.length - 1;
            const globalIndex = (pageNumber - 1) * itemsPerPage + index;
            const isLastOverallRow = isLastPage && isLastDataRow;

            return (
              <tr key={`${pageNumber}-${index}`} className="hover:bg-gray-50">
                <td
                  className={`col-sno text-[0.55rem] px-1 py-0.5 pl-1 ${
                    isLastOverallRow ? "rounded-bl-lg" : ""
                  }`}
                >
                  {globalIndex + 1}
                </td>

                <td className="col-desc text-[0.5rem] px-1 py-0.5">
                  <div>{value?.name}</div>
                </td>

                <td className="col-unit text-[0.55rem] text-center px-1 py-0.5">
                  {value?.unit_name}
                </td>

                <td className="col-price text-[0.55rem] text-center px-1 py-0.5">
                  {value?.sale_price?.toFixed(3)}
                </td>

                <td className="col-qty text-[0.55rem] text-center px-1 py-0.5">
                  {value?.quantity?.toFixed(3)}
                </td>

                <td className="col-vat text-[0.55rem] text-center px-1 py-0.5">
                  {value?.tax}% ({value?.tax_amount?.toFixed(3)})
                </td>

                <td className="col-total text-[0.55rem] text-right pr-2">
                  {value?.total?.toFixed(3)}
                </td>
              </tr>
            );
          })}

          {pageItems.length < itemsPerPage &&
            Array.from({
              length: itemsPerPage - pageItems.length,
            }).map((_, index, arr) => {
              const isLastEmptyRow = index === arr.length - 1;
              const lastRowRounded = isLastPage && isLastEmptyRow;

              return (
                <tr
                  key={`empty-${pageNumber}-${index}`}
                  className="hover:bg-gray-50"
                >
                  <td
                    className={`text-[0.55rem] py-0.5 pl-1 ${
                      lastRowRounded ? "rounded-bl-lg" : ""
                    }`}
                  >
                    &nbsp;
                  </td>
                  <td className="px-2 py-1">&nbsp;</td>
                  <td className="px-2 py-1">&nbsp;</td>
                  <td className="px-2 py-1">&nbsp;</td>
                  <td className="px-2 py-1">&nbsp;</td>
                  <td className="px-2 py-1">&nbsp;</td>
                  <td
                    className={`text-right text-[0.55rem] p-1 pr-2 ${
                      lastRowRounded ? "rounded-br-lg" : ""
                    }`}
                  >
                    &nbsp;
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>

      {isLastPage && (
        <div className="border border-gray-300 rounded-lg p-0.5 mt-1 shadow-sm">
          <div className="flex justify-between">
            <div className="text-[0.6rem] w-1/2">
              <div className="font-semibold mb-1 text-[0.65rem]">
                Total in words&nbsp;:&nbsp;
                <span className="font-normal">
                  <CurrencyWord amount={values?.total?.toFixed(3)} />
                </span>
              </div>
            </div>

            <div className="text-[0.6rem] w-1/2">
              <table className="w-full text-[0.6rem]">
                <tbody>
                  <tr>
                    <td className="text-right pr-1 py-0.5">Subtotal</td>
                    <td className="text-right w-20 py-0.5">
                      {values?.subtotal?.toFixed(3)}
                    </td>
                  </tr>

                  <tr>
                    <td className="text-right pr-1 py-0.5">VAT (5%)</td>
                    <td className="text-right py-0.5">
                      {values?.taxamount?.toFixed(3)}
                    </td>
                  </tr>

                  <tr>
                    <td className="text-right pr-1 py-0.5">Discount</td>
                    <td className="text-right py-0.5">
                      {values?.discount_type
                        ? values?.discount_value
                          ? `${values?.discount?.toFixed(3)} (-${values?.discount_value}%)`
                          : "0.000"
                        : values?.discount
                          ? `-${values?.discount?.toFixed(3)}`
                          : "0.000"}
                    </td>
                  </tr>

                  <tr>
                    <td className="text-right pr-1 py-1 font-semibold">
                      Total (<UserCurrency />)
                    </td>
                    <td className="text-right py-1 font-semibold">
                      {values?.total?.toFixed(3)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );

  <div
    className="pt-4 text-regular text-sm"
    dangerouslySetInnerHTML={{ __html: values?.note }}
  />;
  return (
    <div className="a5-invoice" ref={ref}>
      <style>
        {`
            @media print {
              .a5-invoice {
                page-break-before: always;
              }
              
             @page {
                size: A5 landscape;
                margin: 4mm;
              }
              
              .a5-invoice {
                page-break-inside: avoid;
              }
              
              .header-section {
                display: block !important;
              }
              
              .table-header-section {
                display: block !important;
              }
            }
            
            @media screen {
              .header-section {
                position: static;
              }
              
              .table-header-section {
                position: static;
              }
              
              .invoice-content {
                margin-top: 0;
              }
              
              .page-break {
                margin-top: 0;
                page-break-before: auto;
              }
  
                .invoice-table {
              table-layout: fixed;
              width: 100%;
            }
  
            .col-sno     { width: 5%; }
            .col-desc    { width: 23%; }
            .col-batch   { width: 12%; }
            .col-unit    { width: 6%; }
            .col-qty     { width: 6%; }
            .col-price   { width: 10%; }
            .col-vat     { width: 6%; }
            .col-vatamt  { width: 12%; }
            .col-total   { width: 10%; }
            }
          `}
      </style>

      {renderHeaderSection()}

      {renderTableHeaders()}

      {Array.from({ length: totalPages }, (_, i) => i + 1).map((pageNumber) => {
        const pageItems = getItemsForPage(pageNumber);
        const isLastPage = pageNumber === totalPages;
        return renderTableBody(pageItems, pageNumber, isLastPage);
      })}
    </div>
  );
});

export default InvoiceA5;
